var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-3" },
    [
      _vm.store.loading
        ? _c("CenterOnParent", [_c("Spinner")], 1)
        : _c(
            "div",
            [
              _c("VueGoodTable", {
                attrs: {
                  columns: _vm.columnsConfig,
                  rows: _vm.store.contacts,
                  "pagination-options": _vm.paginationOptions,
                  "search-options": _vm.searchOptions
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-row",
                    fn: function(props) {
                      return [
                        props.column.field === "actions"
                          ? _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.onEditContact(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-pen" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-danger",
                                  on: {
                                    click: function($event) {
                                      return _vm.onContactRemove(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    props.formattedRow[props.column.field]
                                  ) +
                                  "\n        "
                              )
                            ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group mt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function($event) {
                        return _vm.onNewContact()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: {
                      click: function($event) {
                        return _vm.openUploadModal()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-upload" })]
                )
              ]),
              _vm._v(" "),
              _c("ContactEditModal", {
                ref: "editModal",
                attrs: {
                  availableSalutations: _vm.availableSalutations,
                  details: true
                },
                on: { save: _vm.onSave }
              }),
              _vm._v(" "),
              _c("ContactUploadModal", {
                ref: "importModal",
                on: { uploaded: _vm.onUploaded }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }